import React from 'react';
import * as Styles from './FaqReferrer.styles';
import { Accordion } from 'gatorcomponents';

const FaqReferrer = ({
  title,
  faqItems,
  accordionsOpened,
  setAccordionsOpened,
  testId = 'faq-referrer',
}) => (
  <Styles.Wrapper data-testid={testId}>
    <Styles.Title>{title}</Styles.Title>
    <Styles.FaqItemsWrapper>
      {faqItems.map((item, index) => (
        <React.Fragment key={item.id || item.title}>
          <Accordion
            title={item.title}
            width="full"
            withIcon={false}
            actions={null}
            subtitle={false}
            withShadow={false}
            withBorder
            chevronColor="primaryBlue"
            items={() => (
              <Styles.Description>{item.description}</Styles.Description>
            )}
            open={index === accordionsOpened}
            onToggleAccordion={() => setAccordionsOpened(index)}
          />
        </React.Fragment>
      ))}
    </Styles.FaqItemsWrapper>
  </Styles.Wrapper>
);

export default FaqReferrer;
